import axios from 'axios';
import { GET_LOT } from '../../constants';

export const fetchLot = (lId, onError) => (dispatch) => {
  const token = localStorage.jwtToken;
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  dispatch(loadGetLot());

  axios
    .get(`lots/getLot?lotId=${lId}`, config)
    .then((res) => dispatch(setGetLot(res)))
    .catch((err) => {
      dispatch(errorGetLot(err.response));
      onError(err.response);
    });
};

export const loadGetLot = () => ({
  type: GET_LOT.LOAD,
});

export const setGetLot = (lot) => ({
  type: GET_LOT.SUCCESS,
  payload: lot.data.data,
});

export const errorGetLot = (error) => ({
  type: GET_LOT.FAIL,
  payload: error,
});
